module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAABECAYAAAA4E5OyAAABAUlEQVR4Xu3bwQ3CMBBE0d0KaCbdUAENUUKqSTF0YAQoFwsiVvIl1vMhp1w8mb8zQkvGhKe1do+IW+VqmZmv99+P2Q5Bui9KEIIcQ84hHMIhpSCEDGQgA5mSApCBTMkwUgYykJkYma09IuJSuOEaS14L78e5ZghBum9LEIIc484hHMIhlUgMyEAGMpApKQAZyJQMI2UgA5l5kdlaK11u+WzdlM6pZghBupUqghBkx/370h2HcAiH/IhEyHTCEIQgx/WRQziEQwb8G0IxU8wUM8Xsv19rxK7YFbtid/fAuKU7PUQP0UP0ED1k4CazoWqoGqqGqqFqqPYeUN07RQgyUJAnHmFCYz5JpCUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/iconsignalstatetwo.png
// module id = 6NWH
// module chunks = 1